import * as React from "react";

//store, state
import { useAllPermissionCheck } from "../../../store/base";
import useActiveFilters from "../../../hooks/useActiveFilters";

//components & styles
import InspectionsTable from "../../../components/Tables/InspectionErrands/FullTable";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import { PrimaryButton } from "../../../components/Forms/Base/Buttons";
import InspectionErrandModalForm from "../../../components/Forms/InspectionErrand/ChapterForm/ModalForm";

export default function Inspections() {
  const { filteredRealEstates } = useActiveFilters();

  const [createInspectionOpenOpen, setCreateInspectionOpen] =
    React.useState(false);

  const canAdd = useAllPermissionCheck([
    "add_can_inspectionerrand",
    "allow_errand_inspections",
  ]);

  const query = {
    realestate_ids: filteredRealEstates,
  };

  return (
    <>
      {canAdd && (
        <InspectionErrandModalForm
          method="POST"
          isOpen={createInspectionOpenOpen}
          onCheckout={() => setCreateInspectionOpen(false)}
        />
      )}

      <DetailInnerWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitle>Besiktningar</OverviewTitle>

            {canAdd && (
              <PrimaryButton
                title="Skapa besiktning"
                clicked={() => setCreateInspectionOpen(true)}
              />
            )}
          </OverviewTitleWrapper>
          <InspectionsTable persistantQuery={query} />
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
